import React from 'react';

interface StudyMaterialsProps {
  domain: string;
}

const StudyMaterials: React.FC<StudyMaterialsProps> = ({ domain: _domain }) => {
  return (
    <div className="card shadow-sm">
      <div className="card-header bg-white py-3">
        <h5 className="mb-0">
          <i className="bi bi-folder me-2 text-primary-custom"></i>
          Study Materials
        </h5>
        <small className="text-muted">Upload and manage study resources</small>
      </div>
      <div className="card-body">
        <p className="text-muted">Study materials module - Upload notes, presentations, videos, documents</p>
      </div>
    </div>
  );
};

export default StudyMaterials;
